var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { DataGridRow } from './Row.styles';
import { GridStateContext } from '../Grid';
import { removeUndefined } from '../utils';
export var Row = React.memo(function (props) {
    var state = React.useContext(GridStateContext);
    var appearance = props.appearance, minWidth = props.minWidth, cursor = props.cursor, density = props.density, onClick = props.onClick, rowProps = __rest(props
    /**
     * Map cellProps from row props and GridState cellProps
     *
     * Props intended for row's cells, passed to the row,
     * will override props cellProps passed from GridStateContext
     *
     * Similarly, props passed directly to a child cell
     * will override both Row and GridState props
     */
    , ["appearance", "minWidth", "cursor", "density", "onClick"]);
    /**
     * Map cellProps from row props and GridState cellProps
     *
     * Props intended for row's cells, passed to the row,
     * will override props cellProps passed from GridStateContext
     *
     * Similarly, props passed directly to a child cell
     * will override both Row and GridState props
     */
    var cellProps = removeUndefined({
        appearance: appearance,
        minWidth: minWidth,
        cursor: cursor,
        density: density,
        onClick: onClick
    });
    /**
     * Map rowProps from GridState to row
     *
     * Props passed to the row will override rowProps
     * passed from GridStateContext
     */
    var combined = __assign(__assign({}, state.rowProps), rowProps);
    /**
     * New provider value to incorporate override
     * higher provider's cellProps values
     */
    var value = __assign(__assign({}, state), { cellProps: __assign(__assign({}, state.cellProps), cellProps) });
    return (React.createElement(DataGridRow, __assign({}, combined),
        React.createElement(GridStateContext.Provider, { value: value }, props.children)));
});
//# sourceMappingURL=index.js.map